<template>
  <div class="my-10">
    <div class="flex flex-row flex-wrap 0">
      <h1 class="text-center text-l">
        <strong>{{ standard }} - {{ $t(name) }}</strong>
      </h1>
    </div>
    <div class="flex flex-row flex-wrap">
      <div class="w-full lg:w-1/5 py-10">
        <img :src="src" :alt="alt" class="w-40 block m-auto" />
      </div>
      <div
        v-html="$t(contentName)"
        class="w-full lg:w-3/5 py-5 px-4 md:px-10"
      ></div>
      <div class="w-full lg:w-1/5">
        <div class="flex flex-row flex-wrap items-center">
          <a
            id="downloadHidden"
            :href="filePath"
            :download="standard"
            class="btn h-32 w-full text-center text-4xl mt-10"
          >
            <i class="fa fa-download"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: true
    },
    contentName: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    standard: {
      type: String,
      required: true
    },
    filePath: {
      type: String,
      required: true
    }
  },
  methods: {
    triggerDownload() {
      document.getElementById('downloadHidden').click()
    }
  }
}
</script>

<style scoped></style>
